var LI_REPORTING_KEY = 'li-module-enabled';
var pbjs = (window.pbjs = window.pbjs || { que: [] });
var googletag = (window.googletag = window.googletag || { cmd: [] });

/* 
 * Initializes Live Intent for a given id.
 */
export function initLiveIntent(liveIntentBrandConfig) {
  if (!liveIntentBrandConfig) {
    console.warn('LiveIntent not configured for this brand.');
    return;
  }
  try {
    var liveIntentId = liveIntentBrandConfig.id;
    var control = liveIntentBrandConfig.control || 5;
    var treatedGroup = (100 - control) / 100;
    if (!window.liModuleEnabled) {
      // To manage the control group selection externally, override this value
      // true: treated group, false: control group.
      window.liModuleEnabled = Math.random() < treatedGroup;
    }

    var auctionsEnriched = {};
    setTargeting();

    pbjs.que.push(function () {
      // Enable the module, only if the visit is in the treated group
      if (window.liModuleEnabled) {
        pbjs.mergeConfig({
          userSync: {
            auctionDelay: 300,
            userIds: [
              {
                name: "liveIntentId",
                params: {
                  publisherId: liveIntentId,
                  emailHash: window.websiteUserEmail,
                  requestedAttributesOverrides: {
                    uid2: true,
                    bidswitch: true,
                    medianet: true,
                    magnite: true,
                    pubmatic: true,
                    index: true,
                    openx: true,
                    thetradedesk: true,
                    sovrn: true,
                    vidazoo: true,
                    sonobi: true,
                    sharethrough: true,
                    triplelift: true,
                    zetassp: true,
                    nexxen: true
                  },
                },
                storage: {
                  type: "html5",
                  name: "__tamLIResolveResult",
                  expires: 1,
                },
              },
            ],
          },
        });
        // Needed because of Prebid bug as pointed out by LiveIntent team.
        pbjs.refreshUserIds({ submoduleNames: ["liveIntentId"] });
      }

      pbjs.onEvent("auctionInit", function (args) {
        auctionsEnriched[args.auctionId] =
          args.adUnits &&
          args.adUnits.some(
            (au) =>
            au.bids &&
            au.bids.some(
              (b) =>
              b.userIdAsEids &&
              b.userIdAsEids.some(
                (eid) =>
                eid.source === "liveintent.com" ||
                (eid.uids &&
                  eid.uids.some(
                    (uid) =>
                    uid.ext && uid.ext.provider === "liveintent.com"
                  ))
              )
            )
          );
        setTargeting(auctionsEnriched[args.auctionId]);

      });
    });

    } catch(e) {
    console.error('Error initializing Live Intent: ', e);
  }
}

function setTargeting(enriched) {
    googletag.cmd.push(function () {
    var targeting = window.liModuleEnabled ? "t1" : "t0";
    if (enriched !== undefined) targeting += enriched ? "-e1" : "-e0";
    googletag.pubads().setTargeting(LI_REPORTING_KEY, targeting);
  });
}
